const isValidOrgId = (orgId) => {
  return orgId && orgId.indexOf("org_") >= 0;
};

export { isValidOrgId };
